import React from 'react';
import { Field } from 'formik';
import Section from '../form/Section';
import DropdownWithChange from '../form/DropdownWithChange';
import TextInput from '../form/TextInput';
import RadioGroup from '../form/RadioGroup';
import Checkbox from '../form/Checkbox';
import { employmentOptions, sponsorshipOptions } from '../../store';

const OrganizationInfomation = ({ values, setFieldValue }) => {
  /**
   * employed handler
   * @param {*} e
   */
  const employedHandler = (e) => {
    const val = e.target.value;

    if (parseInt(val) === 0) {
      setFieldValue('company_name', '');
      setFieldValue('job_title', '');
    }

    setFieldValue('employed', val);
  };

  /**
   * sponsorship Handler
   * @param {*} val
   */
  const sponsorshipHandler = (val) => {
    const v = parseInt(val);
    if (val === 0) {
      setFieldValue('billing_contact_salutation', '');
      setFieldValue('billing_contact_first_name', '');
      setFieldValue('billing_contact_last_name', '');
      setFieldValue('billing_contact_company', '');
      setFieldValue('billing_contact_job_title', '');
      setFieldValue('billing_contact_email', '');
      setFieldValue('billing_contact_no', '');
      setFieldValue('billing_address', '');
    }
    setFieldValue('sponsorship', v);
  };

  return (
    <Section title='Organisation Information'>
      {values.citizenship !== 'Non-Singapore Citizen/PR' && (
        <div className='flex mb-2 flex-col md:flex-row'>
          <div className='w-full mr-0 md:w-1/2 md:mr-3'>
            <Field
              label='Employment Status'
              name='employed'
              value={values.employed}
              required
              options={employmentOptions}
              component={DropdownWithChange}
              change={employedHandler}
            />
          </div>
          <div className='w-1/2 ml-3'></div>
        </div>
      )}
      {(parseInt(values.employed).toString() === '1' ||
        values.employed === '2') && (
        <div className='flex mb-2 flex-col md:flex-row  '>
          <div className='w-full mr-0 md:w-1/2 md:mr-3'>
            <Field
              label='Company Legal Entity Name'
              name='company_name'
              value={values.company_name}
              required
              component={TextInput}
            />
          </div>
          <div className='w-full ml-0 md:w-1/2 md:ml-3'>
            <Field
              label='Job Title'
              name='job_title'
              value={values.job_title}
              required
              component={TextInput}
            />
          </div>
        </div>
      )}
      <div className='flex mb-2 flex-col md:flex-row'>
        <div className='w-full mr-0 md:w-1/2 md:mr-3'>
          <Field
            label='Sponsorship'
            name='sponsorship'
            value={values.sponsorship}
            required
            options={sponsorshipOptions}
            component={RadioGroup}
            change={(val) => sponsorshipHandler(val)}
          />
        </div>
        <div className='w-1/2 ml-3'></div>
      </div>
      {values.sponsorship === 0 && (
        <div className='flex mb-2'>
          <div>
            <Field
              label='I intend to use my unutilized SkillsFuture Credits'
              name='skillsfuture_credit'
              value={values.skillsfuture_credit}
              component={Checkbox}
              tooltip='All Singaporeans aged 25 and above can use their $500 Skills Future Credit from the government to pay for a wide range of approved skills-related courses.'
            />
          </div>
          <div></div>
        </div>
      )}
      {values.sponsorship === 1 && (
        <div className='flex mb-2 flex-col md:flex-row'>
          <div>
            <Field
              label='SME'
              name='sme'
              value={values.sme}
              tooltip='SMEs are defined as companies with: (i) at least 30% local shareholding; AND (ii) Group annual sales turnover of not more than $100 million OR Group employment size of not more than 200 employees.'
              component={Checkbox}
            />
            <Field
              label='Government Business Unit'
              name='government_business_unit'
              value={values.government_business_unit}
              component={Checkbox}
            />
            <Field
              label='Government Business Unit Code'
              name='government_business_unit_code'
              value={values.government_business_unit_code}
              component={TextInput}
            />
          </div>
        </div>
      )}
    </Section>
  );
};

export default OrganizationInfomation;
